module.exports = __webpack_public_path__ + "img/1355891664.885135fe.jpg";